<template xmlns:v-slot="http://www.w3.org/1999/XSL/Transform">
  <v-container>
    <v-layout>
      <v-flex>
        <v-layout xs4 mb-2>
          <v-flex mt-4>
            <h1>Gestão de Notificações</h1>
          </v-flex>
        </v-layout>
      </v-flex>
    </v-layout>
    <hr class="solid" />
    <v-layout class="card">
      <v-row>
        <v-col>
          <v-btn
            color="primary"
            class="button btn-default white--text"
            @click="dialogNovaNotificacao = true"
            >Nova Notificação</v-btn
          >
        </v-col>
        <v-col>
          <v-btn
            color="primary"
            class="button btn-default white--text"
            @click="acessar(menuRoute('notificacoes'))"
            >Manutenção de Notificações</v-btn
          >
        </v-col>
      </v-row>
    </v-layout>
    <v-dialog
      v-model="dialogNovaNotificacao"
      width="400"
      :scrollable="true"
      content-class="app-content"
      persistent
    >
      <v-card style="border-radius: 16px">
        <v-card-title class="text-h5">
          <v-flex class="d-flex">
            <v-menu bottom left>
              <template v-slot:activator="{ on }">
                <v-btn v-on="on" icon @click="dialogNovaNotificacao = false">
                  <v-icon>fa fa-times</v-icon>
                </v-btn>
              </template>
            </v-menu>
          </v-flex>
        </v-card-title>
        <v-card-text>
          <p class="mt-5 mb-10 text-center"> Escolha o tipo de notificação desejada</p>
          <v-row>
            <v-col>
              <v-btn
                color="primary"
                class="button btn-default white--text"
                @click="acessar(menuRoute('cotas'))"
                >Notificação Avulsa</v-btn
              >
            </v-col>
            <v-col>
              <v-btn
                color="primary"
                class="button btn-default white--text"
                @click="acessar(menuRoute('notificacaoAutomatica'))"
                >Notificações Automática</v-btn
              >
            </v-col>
          </v-row>
        </v-card-text>
      </v-card>
    </v-dialog>
  </v-container>
</template>

<script>
import { alert } from "@/plugins/helpers";

export default {
  name: "Home",
  data: () => ({
    dialogNovaNotificacao: false,
  }),
  methods: {
    emDesenvolvimento() {
      alert("Funcão em desenvolvimento");
    },
    menuRoute(name) {
      try {
        const route = this.$router.resolve({ name }).route;
        const selected = this.$route.path.startsWith(route.path);
        return route.matched.length
          ? { text: route.meta.title, to: route.path, selected }
          : { text: "// fixme" };
      } catch (e) {
        return false;
      }
    },
    acessar(item) {
      if (item.click) {
        item.click();
      } else {
        try {
          if (this.$route.path !== item.to) {
            this.$router.push(item.to);
          }
        } catch (e) {
          return false;
        }
      }
    },
  },
};
</script>